import React from 'react';
import styles from './DocumentSettingsModalExportableCheckbox.module.scss';
import MuiCheckbox from '../../../mui/MuiCheckbox';
import { FormControlLabel, Typography } from '@mui/material';

export type DocumentSettingsModalExportableCheckboxProps = {
	isOwner: boolean;
	checked: boolean;
	setChecked: ( checked: boolean ) => void;
};

export const DocumentSettingsModalExportableCheckbox: React.FC<
DocumentSettingsModalExportableCheckboxProps
> = ( { isOwner, checked, setChecked } ) =>
	isOwner ? (
		<>
			<Typography variant='h6'>Can this document be exported</Typography>
			<FormControlLabel
				labelPlacement='start'
				className={ styles.container }
				control={
					<MuiCheckbox
						checked={ checked }
						onChange={ ( _, checked ) => setChecked( checked ) }
					/>
				}
				label='Export enabled'
			/>
		</>
	) : null;
